module.exports = __webpack_public_path__ + "img/Group 72.38464e31.png";